// extracted by mini-css-extract-plugin
module.exports = {"primarycontainer_Promo":"Promo_primarycontainer_Promo__29iqI","secondaryContainer":"Promo_secondaryContainer__2VvM5","container_multipleItem":"Promo_container_multipleItem__3wqX6"};